import { Context, Effect, Fiber, Layer, Scope } from "effect";
export class QueryWork extends Context.Service<QueryWork, {
  readonly observe: <A, E, R>(query: Effect.Effect<A, E, R>) => Effect.Effect<A, E, R>;
}>()("workerstation/frontend-preparation/QueryWork") {}
export const QueryWorkLive = (root: Scope.Scope, admission: Scope.Scope = root) => Layer.succeed(QueryWork, QueryWork.of({
  observe: Effect.fn("Frontend.queryWork")(function* <A, E, R>(query: Effect.Effect<A, E, R>) {
    const child = yield* Effect.forkIn(Effect.suspend(() => admission.state._tag === "Closed" || root.state._tag === "Closed" ? Effect.interrupt : Effect.scoped(query)), root);
    return yield* Fiber.join(child).pipe(Effect.ensuring(Fiber.interrupt(child)));
  })
}));
